import React, { useEffect} from "react";
import { BiPlusCircle } from "react-icons/bi";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Breadcrumb from "../common/Breadcrumb";

const AIPhoto = () => {  

  const images = [
    { id: 1, src: "images/gallery/robotics-01.png", alt: "AI", title: "AI", group: "AI" },
    { id: 2, src: "images/gallery/robotics-02.png", alt: "AI", title: "AI", group: "AI" },
    { id: 3, src: "images/gallery/robotics-03.png", alt: "AI", title: "AI", group: "AI" },
    { id: 4, src: "images/gallery/robotics-04.png", alt: "AI", title: "AI", group: "AI" },
    { id: 58, src: "images/gallery/01.png", alt: "AI", title: "AI", group: "AI" },
    { id: 59, src: "images/gallery/02.png", alt: "AI", title: "AI", group: "AI" },
    { id: 60, src: "images/gallery/03.png", alt: "AI", title: "AI", group: "AI" },
    { id: 61, src: "images/gallery/04.png", alt: "AI", title: "AI", group: "AI" },
    { id: 62, src: "images/gallery/05.png", alt: "AI", title: "AI", group: "AI" },
    { id: 63, src: "images/gallery/06.png", alt: "AI", title: "AI", group: "AI" },
    { id: 64, src: "images/gallery/07.png", alt: "AI", title: "AI", group: "AI" },
    { id: 65, src: "images/gallery/08.png", alt: "AI", title: "AI", group: "AI" },
    { id: 66, src: "images/gallery/09.png", alt: "AI", title: "AI", group: "AI" },
    { id: 67, src: "images/gallery/10.png", alt: "AI", title: "AI", group: "AI" },
    { id: 68, src: "images/gallery/11.png", alt: "AI", title: "AI", group: "AI" },
    { id: 69, src: "images/gallery/12.png", alt: "AI", title: "AI", group: "AI" },
    { id: 70, src: "images/gallery/13.png", alt: "AI", title: "AI", group: "AI" },
    { id: 71, src: "images/gallery/14.png", alt: "AI", title: "AI", group: "AI" },
    { id: 72, src: "images/gallery/15.png", alt: "AI", title: "AI", group: "AI" },
    { id: 73, src: "images/gallery/16.png", alt: "AI", title: "AI", group: "AI" },
    { id: 74, src: "images/gallery/17.png", alt: "AI", title: "AI", group: "AI" },
    { id: 75, src: "images/gallery/18.png", alt: "AI", title: "AI", group: "AI" },
    { id: 76, src: "images/gallery/19.png", alt: "AI", title: "AI", group: "AI" },
    { id: 77, src: "images/gallery/20.png", alt: "AI", title: "AI", group: "AI" },
    { id: 78, src: "images/gallery/21.png", alt: "AI", title: "AI", group: "AI" },
    { id: 79, src: "images/gallery/22.png", alt: "AI", title: "AI", group: "AI" },
    { id: 80, src: "images/gallery/23.png", alt: "AI", title: "AI", group: "AI" },
    { id: 81, src: "images/gallery/24.png", alt: "AI", title: "AI", group: "AI" },
    { id: 82, src: "images/gallery/25.png", alt: "AI", title: "AI", group: "AI" },
    { id: 83, src: "images/gallery/26.png", alt: "AI", title: "AI", group: "AI" },
    { id: 84, src: "images/gallery/27.png", alt: "AI", title: "AI", group: "AI" },
    { id: 85, src: "images/gallery/28.png", alt: "AI", title: "AI", group: "AI" },
    { id: 86, src: "images/gallery/29.png", alt: "AI", title: "AI", group: "AI" },
    { id: 87, src: "images/gallery/30.png", alt: "AI", title: "AI", group: "AI" },
    { id: 88, src: "images/gallery/31.png", alt: "AI", title: "AI", group: "AI" },
    { id: 89, src: "images/gallery/32.png", alt: "AI", title: "AI", group: "AI" },
    { id: 90, src: "images/gallery/33.png", alt: "AI", title: "AI", group: "AI" },
    { id: 91, src: "images/gallery/34.png", alt: "AI", title: "AI", group: "AI" },
    { id: 92, src: "images/gallery/35.png", alt: "AI", title: "AI", group: "AI" },
    { id: 93, src: "images/gallery/36.png", alt: "AI", title: "AI", group: "AI" },
    // { id: 94, src: "images/gallery/37.png", alt: "AI", title: "AI", group: "AI" },
    { id: 95, src: "images/gallery/38.png", alt: "AI", title: "AI", group: "AI" },
    { id: 96, src: "images/gallery/39.png", alt: "AI", title: "AI", group: "AI" },
    { id: 97, src: "images/gallery/40.png", alt: "AI", title: "AI", group: "AI" },
    { id: 98, src: "images/gallery/41.png", alt: "AI", title: "AI", group: "AI" },    
  ];

  useEffect(() => {
    NativeFancybox.bind("[data-fancybox='gallery']", {
      infinite: true,
      Toolbar: {
        display: {
          left: ["infobar"],
          right: ["slideshow", "thumbs", "close"],
        },
      },
      Thumbs: {
        autoStart: false,
      },
      caption: (fancybox, slide) => {
        return slide.$trigger?.dataset?.caption || slide.$trigger?.title || "";
      },
    });

    return () => {
      NativeFancybox.destroy();
    };
  }, []);


  return (
    <>
      <Breadcrumb
        pageTitle="Gallery"
        breadcrumbItems={[
          { label: "Home", link: "/" },
          { label: "AI & Robotics Lab" },
        ]}
        backgroundImage="images/banner/slide-2.png"
      />

      <section className="space-ptb">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <div className="section-title">
                <h2>AI & Robotics Lab</h2>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="my-shuffle-container row columns-4 popup-gallery full-screen">
                {images.map((image) => (
                  <div key={image.id} className="grid-item" data-group={image.group}>
                    <div className="portfolio-item">
                      <div className="position-relative">
                        <img
                          className="img-fluid"
                          src={image.src}
                          alt={image.alt}
                          loading="lazy"
                        />
                        <div className="portfolio-overlay">
                          <a
                            data-fancybox="gallery"
                            data-caption={image.title}
                            href={image.src}
                            title={image.title}
                            className="portfolio-img"
                          >
                            <i>
                              <BiPlusCircle size={40} />
                            </i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AIPhoto;
